import { configure, sortBy } from "instantsearch.js/es/widgets";
import { getInstance, registerWidget } from "./searchsync-create-instance";

function initSortByWidget() {
  const tgblAlgoliaDataJSON = window.atob(tgblSearchsyncDataEncoded);
  const tgblAlgoliaData = jQuery.parseJSON(tgblAlgoliaDataJSON);

  // Get all elements with sortBy class
  const elements = document.querySelectorAll("[data-filter-type='sortBy']");
  const elementsArray = Array.from(elements);

  // Group together sortBy elements that share an index
  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute("data-index");
    if (!acc[dataIndexValue]) {
      acc[dataIndexValue] = [];
    }
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  // Loop through each index
  for (const dataIndexValue in elementsGroupedByIndex) {
    if (!elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) continue;

    const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];
    const search = getInstance(dataIndexValue);

    // Helper to switch the index for this InstantSearch context
    const switchIndex = (defaultIndex) => {
      try {
        // Prefer scoped helper in multi-index setups
        const scoped =
          search.mainIndex && typeof search.mainIndex.getIndexById === "function"
            ? search.mainIndex.getIndexById(dataIndexValue)
            : null;

        const helper =
          (scoped && typeof scoped.getHelper === "function" && scoped.getHelper()) ||
          search.helper;

        if (!helper) {
          console.warn("[searchsync] No helper found to set index for", dataIndexValue);
          return;
        }

        if (helper.state.index !== defaultIndex) {
          helper.setIndex(defaultIndex);
          search.refresh();
        }
      } catch (e) {
        console.warn("[searchsync] Failed to set index for", dataIndexValue, e);
      }
    };

    // Perform actions on elements with the same data-index value
    elementsWithSameIndex.forEach((element) => {
      const widgetID = element.getAttribute("data-id");
      const widgetData = tgblAlgoliaData[widgetID];
      const items = Object.values(widgetData["sort_by_label_to_index_map"]);
      const defaultIndex = widgetData["default_index"];

      // Switch the index when the instance is created (or immediately if already started)
      const applyDefaultIndex = () => switchIndex(defaultIndex);
      if (search.started) {
        applyDefaultIndex();
      } else {
        window.addEventListener("searchsyncInstanceCreated", applyDefaultIndex, { once: true });
      }

      // Add widgets (keeping your structure)
      let SearchsyncSortBy = ($, search, element) => {
        search.addWidgets([

          sortBy({
            container: element,
            items: items,
            cssClasses: {
              root: "",
              list: "tgbl-refinement-list",
              item: "tgbl-refinement-list__item tgbl-refinement-item",
              selectedItem: "",
              label: "tgbl-refinement-item__label",
              labelText: "tgbl-refinement-item__text",
              checkbox: "tgbl-refinement-item_checkbox",
              count: "",
            },
          }),
        ]);
        registerWidget(element);
      };

      SearchsyncSortBy($, search, element);
    });
  }
}

export { initSortByWidget };
